import {GatewayStatusEnum} from "../gateway/GatewayStatusEnum";

export class GatewayWorkflowStatus {
  gatewayId!: number;
  status!: GatewayStatusEnum;
  ts!: number;

  constructor(gatewayId: number, status: GatewayStatusEnum, ts: number = new Date().getTime()) {
    this.gatewayId = gatewayId;
    this.status = status;
    this.ts = ts;
  }

}
